<div class="home">
  <div class="home__header">
    <img class="home__picture" [src]="fotoPerfil" alt="Foto de perfil" />
    <div class="home__info">
      <h1 class="home__title">¡Hola, <span class="home__username">{{ nombre }}</span>!</h1>
      <p class="home__subtitle">Bienvenido a U360, nos encanta verte por acá</p>
      <p class="home__description">
        Acá podrás construir tu perfil 360. Descubre tus competencias, explora oportunidades y prepárate para tu próxima
        gran aventura.
      </p>
    </div>
    <button class="home__activate" (click)="openSimulationChart()">Activa tu perfil 🚀</button>
  </div>

  <h2 class="bento__title">Completa tu perfil U360 siguiendo estos pasos:</h2>

  <div class="bento">
    <div class="bento__tile" *ngFor="let step of steps; let i = index"
      [ngClass]="{ 'bento__tile--span3': i === 0 || i === 3, 'bento__tile--span1': i === 1 || i === 2 }">
      <h3 class="bento__step">Paso {{ i + 1 }}: {{ step.title }}</h3>
      <div class="bento__content">
        <a *ngFor="let action of step.actions" class="bento__action" [routerLink]="action.link">
          <img class="bento__icon" [src]="action.icon" [alt]="action.title" />
          <div class="bento__text">
            <p class="bento__title-action">{{ action.title }}</p>
          </div>
        </a>
      </div>
    </div>
  </div>

  <button class="home__help" (click)="openWhatsApp()">
    ¿Necesitas ayuda? 💬
  </button>
</div>